// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"v4-z","dimensionLabel":"w4-z","styleChooserControlWrapper":"x4-z","styleChooserControl":"y4-z","disabled":"z4-z","giftCard":"A4-z","styleChooserText":"B4-z"};